var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlyphClioGlyphBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1317.76 1317.95",
    style: {
      enableBackground: "new 0 0 1317.76 1317.95"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0070E0;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1173.18,251.67l128.9-180.45l-160.64,143.41C1021.61,85.14,850.28,4,659.94,4C297.66,4,4,297.67,4,659.97 c0,362.28,293.66,655.97,655.94,655.97c362.28,0,656.01-293.69,656.01-655.97C1315.95,505.56,1262.46,363.73,1173.18,251.67z  M1116.38,876.67c0,132.4-107.32,239.74-239.74,239.74h-433.4c-132.38,0-239.74-107.34-239.74-239.74V443.29 c0-132.44,107.35-239.76,239.74-239.76h433.4c73.17,0,138.57,32.87,182.54,84.54L657.39,646.76L385.25,461.72l197.01,379.41 c1.23,2.08,3.01,3.93,4.43,5.94c0.77,1.05,1.49,2.06,2.33,3.1c1.94,2.6,3.54,5.35,5.82,7.79c1.88,2.03,4.13,3.56,6.19,5.41 c0.04,0.07,0.09,0.12,0.09,0.12c0.12,0.11,0.2,0.14,0.23,0.2c25.05,22.49,58.61,30.12,89.69,22.42c0.29-0.06,0.6-0.14,0.91-0.23 c5.6-1.42,11.05-3.36,16.38-5.82c0.85-0.37,1.69-0.8,2.49-1.19c4.7-2.31,9.18-4.96,13.54-8.08c1.37-0.94,2.65-1.99,4-3.04 c2.17-1.69,4.48-3.04,6.51-4.96c1.56-1.44,2.7-3.17,4.13-4.68c0.68-0.71,1.46-1.21,2.13-1.92l2.17-2.95 c2.77-3.36,5.34-6.81,7.61-10.44l348.47-487.8c10.85,27.35,17,57.09,17,88.31V876.67z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlyphClioGlyphBlue);
export default __webpack_public_path__ + "static/media/Glyph_Clio Glyph Blue.03b0476d6bc1bc3ad77fae3c4a4aabba.svg";
export { ForwardRef as ReactComponent };